// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportList.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { observe } from 'mobx';
import connect from 'share/enhancers/Izenda.Connect';
import ReportItem from './Izenda.ReportItem';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import classnames from 'classnames';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import constants from 'logic/data/Izenda.ReportsConstants';
import BoardListHeader from 'share/components/controls/Izenda.BoardListHeader';
import LazyLoading from 'share/components/controls/LazyLoading/Izenda.LazyLoading';
import actions from './Izenda.ReportListAction';
import { omit, isEqual, has, isNil, forEach, getOr, size, isEmpty } from 'lodash/fp';
import UiState from 'logic/Izenda.UiState';

const ReportListHeader = BoardListHeader(constants);

class ReportList extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.loader.startLoading();
  }

  componentDidMount() {
    const { props } = this;
    const { loader, store } = props;

    this.disposeObserveTenantID = observe(UiState, 'tenantId', () => {
      const {
        params: { catId, reportType, isGlobal },
      } = props;
      this.isReload = true;
      loader.startLoading();
      store.loadLazyLoadingReports(catId, reportType, true, isGlobal).finally(loader.endLoading.bind(loader));
    });

    store.resetReportData();
    loader.endLoading();
  }

  componentWillReceiveProps(nextProps) {
    const nextLocation = omit(['key', 'action', 'state'], nextProps.location);
    const currentLocation = omit(['key', 'action', 'state'], this.props.location);
    const restNextProps = omit(['isGlobalExpand', 'isLocalExpand', 'location'], nextProps);
    const restProps = omit(['isGlobalExpand', 'isLocalExpand', 'location'], this.props);
    if (!isEqual(nextLocation, currentLocation) || !isEqual(restNextProps, restProps)) {
      const {
        store,
        params: { catId, reportType, isGlobal },
        loader
      } = nextProps;
      this.isReload = true;
      loader.startLoading();
      store.loadLazyLoadingReports(catId, reportType, true, isGlobal).finally(loader.endLoading.bind(loader));
    }
  }

  componentWillUnmount() {
    this.disposeObserveTenantID();
  }

  renderSubReport = groupInfo => {
    let {
      isGlobalExpand,
      isLocalExpand,
      toggle,
      params: { reportId },
      reportSubscriptionStore,
      store
    } = this.props;

    if (has('globalLocalCategory', groupInfo)) {
      return renderGlobalLocalCategory.call(this, groupInfo);
    }

    return (
      <ReportItem
        {...groupInfo}
        selectedReportId={reportId}
        reportSubscriptionStore={reportSubscriptionStore}
        store={store}
      />
    );

    function renderGlobalLocalCategory(groupInfo) {
      var isGlobal = groupInfo.isGlobal;
      var expandCollapse = classnames({
        'icon-minus-circled': (isGlobal && isGlobalExpand) || (!isGlobal && isLocalExpand),
        'icon-plus-circled': (isGlobal && !isGlobalExpand) || (!isGlobal && !isLocalExpand)
      });

      var className = classnames({
        u_paddingTop: !isGlobal && this.globalLocalCount === 2
      });

      return (
        <GridLayout className={className}>
          <GridLayout.Row className="u_paddingTopBottom u_noMarginAll izenda-GlobalLocalItem">
            <GridLayout.Col cols={11}>
              <div className="u_textBold u_textUppercase">{groupInfo.globalLocalCategory.name}</div>
            </GridLayout.Col>
            <GridLayout.Col cols={1}>
              <div className="u_floatRight">
                <a onClick={toggle.bind(this.props, isGlobal)}>
                  <span className={expandCollapse} />
                </a>
              </div>
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    }
  };

  render() {
    let {
      loader,
      store,
      params: { isGlobal, catId, reportType },
      isGlobalExpand,
      isLocalExpand
    } = this.props;

    this.globalLocalCount = 0;
    let reportList = getReportList.call(this, store.items.categories);
    const getData = getDataFunc();

    return (
      <div className="izenda-Wrapper izenda-ReportList">
        <ReportListHeader
          ref="reportListHeader"
          store={store}
          isTemplateType={store.isTemplateType}
          className="izenda-Wrapper-header"
          isGlobal={isGlobal}
        />
        <section className="izenda-ReportList-content izenda-Wrapper-content u_paddingLeftRight">
          <ScrollBox>
            <LazyLoading
              data={reportList}
              isLastPage={store.items.isLastPage}
              getData={getData}
              renderItem={this.renderSubReport}
              registerLazyLoadingStore={store.registerContentLazyLoadingStore.bind(store)}
              loader={isNil(this.isReload) && loader}
            />
          </ScrollBox>
        </section>
      </div>
    );

    function getReportList(globalLocalCategories) {
      let reportList = [],
        reports,
        numReports;

      forEach(globalLocalCategory => {
        this.globalLocalCount++;

        if (globalLocalCategory.isVirtualNode) {
          reportList.push(globalLocalCategory);
          return;
        }

        reportList.push({
          key: globalLocalCategory.isGlobal ? 'GlobalCategory_' + isGlobalExpand : 'LocalCategory_' + isLocalExpand,
          isGlobal: globalLocalCategory.isGlobal,
          globalLocalCategory: globalLocalCategory
        });

        ((globalLocalCategory.isGlobal && isGlobalExpand) || (!globalLocalCategory.isGlobal && isLocalExpand)) &&
          forEach(category => {
            if (category.isVirtualNode) {
              reportList.push(category);
              return;
            }

            if (category.canDelete) return;

            forEach(subCategory => {
              if (subCategory.isVirtualNode) {
                reportList.push(subCategory);
                return;
              }

              if (subCategory.canDelete) return;

              reports = getOr([], 'reports', subCategory);
              numReports = size(reports);

              reports.forEach((report, index) => {
                if (report.isVirtualNode) {
                  reportList.push(report);
                  return;
                }

                reportList.push({
                  key: report.id,
                  isGlobal: category.isGlobal,
                  isFirstItem: index === 0,
                  isLastItem: index === numReports - 1,
                  reportCategory: category,
                  reportSubCategory: subCategory,
                  report: report
                });
              }, subCategory.reports);
            }, category.subCategories);
          }, globalLocalCategory.subCategories);
      }, globalLocalCategories);

      return reportList;
    }

    function getDataFunc() {
      return !isEmpty(store.items.searchText)
        ? store.lazyLoadingSearch.bind(store, isGlobal)
        : store.loadLazyLoadingReports.bind(store, catId, reportType, false, isGlobal);
    }
  }
}

ReportList.propTypes = {
  store: PropTypes.object
};

export default connect(actions)(ReportList);



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportList/Izenda.ReportList.js